<template>
  <v-app-bar color="transparent" class="main-header" dense flat app>
    <v-toolbar dense color="white" class="rounded-b-xl text-IMTGray">
      <v-btn depressed icon @click="ChangeMiniDrawer()">
        <v-icon v-if="miniDrawer">mdi-menu</v-icon>
        <v-icon v-else>mdi-menu-open</v-icon>
      </v-btn>
      <v-breadcrumbs
        v-if="breadcrumbs_items.length > 1"
        :items="breadcrumbs_items"
        dir="rtl"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-left</v-icon>
        </template>
      </v-breadcrumbs>
      <v-toolbar-title v-else class="mr-4"
        ><strong>{{ breadcrumbs_items[0].text }}</strong></v-toolbar-title
      >
    </v-toolbar>
    <div class="p-2"></div>
    <v-toolbar dense color="IMThemeGray" class="rounded-b-xl text-white logo-bar">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="250"
        transition="slide-y-transition"
        offset-y
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" icon dark class="mr-auto">
            <v-badge
              left
              color="red"
              overlap
              :value="notificationCount"
              :content="notificationCount"
            >
              <!-- <img
                src="/media/svg/top-bar-icon/message.svg"
                alt="dash notifications"
                width="30"
              /> -->
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn></template
        >
        <v-card class="text-right">
          <v-list shaped>
            <template v-for="(item, index) in dashNotifications">
              <v-list-item
              
                to="/contact/customers"
                :class="{ newNotifi: !item.isRead }"
               
              >
                <v-list-item-title>{{ item.message }}</v-list-item-title>
                <v-list-item-icon>
                  <v-icon @click="submitRemoveDashNotification(index)">mdi-close</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list>
          <v-card-actions class="justify-content-center">
            <div>
              <v-btn
                v-if="dashNotifications.length > 0"
                text
                @click="
                  menu = false;
                  setRead();
                "
                :disabled="notificationCount == 0"
                color="orange"
              >
                وضع علامة "مقروء"
              </v-btn>
              <h6 v-else>لا توجد إشعارات</h6>
            </div>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-toolbar-title class="mx-auto"
        ><img src="/media/logo/imhere.svg" alt="logo"
      /></v-toolbar-title>
    </v-toolbar>
  </v-app-bar>
</template>
<style lang="scss">
.main-header {
  > .v-toolbar__content {
    padding-left: 0 !important;
  }
}
a {
  text-decoration: none !important;
  color: #6c757d !important;
}
hr {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.newNotifi {
  background-color: #ffac7b;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "Ek-navbar",
  data: () => ({
    menu: false,
    miniDrawer: true,
  }),
  mounted() {
    this.fetchDashNotifications();
  },
  computed: {
    ...mapGetters([
      "notificationList",
      "breadcrumbs_items",
      "dashNotifications",
      "notificationCount",
      "mini",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchDashNotifications",
      "setRead",
      "removeDashNotification",
      "setMiniDrawer",
    ]),
    ChangeMiniDrawer() {
      if (this.miniDrawer) {
        this.miniDrawer = false;
        this.setMiniDrawer(this.miniDrawer);
      } else {
        this.miniDrawer = true;
        this.setMiniDrawer(this.miniDrawer);
      }
    },
    submitRemoveDashNotification(index) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "هل أنت متأكد؟",
          text: "هل فعلاً تريد حذف الإشعار ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم!",
          cancelButtonText: "إلغاء",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            this.removeDashNotification(index);
          }
        });
    },
  },
  watch: {
    mini(newVal) {
      this.miniDrawer = newVal;
    },
    miniDrawer(newVal) {
      this.setMiniDrawer(newVal);
    },
  },
};
</script>
